export enum SensorAuditExecutionMode {
  Local = "local",
  Remote = "remote",
}
